<!--
Home.vue
-->

<template>
	<div>

		<div class="ptop-lg padded">
			<h1 class="mtop-xl mbottom-xl">Page Unavailable</h1>
			<div class="mbottom-xl mtop-xl ptop-xl pbottom-xl"> </div>

	</div>
	</div>
</template>

<script>

export default {
	name: "home",

	components: {
	},
	

	mixins: [
	],

	data() {
		return {
			today: new Date(),
		};

	},

	computed: {


	},

	watch: {
	},

	mounted() {
		this.$store.dispatch("Hold/CHANGE_PAGE_TITLE", "Unavailable");

		if(window.location.hash.includes("frame")){
			window.location.replace("https://wim-internal.usgs.gov/frame");
		}else{
			var redir = "https://wim-internal.usgs.gov/styleguide/" + window.location.hash;
			window.location.replace(redir);
		}
	},
	created: function () {
	},

	beforeDestroy(){
	},
	
	methods: {




	}
};



</script>


<style lang="scss">

	.tool-group{
		display: flex;
		gap: 30px;
		flex-wrap: wrap;

		.tool-link{
			display: flex;
			color: var(--text);
			max-width: 300px;
			min-width: 300px;

			@media (max-width: $screenSM) {
				min-width: 90%;
				max-width: 90%;
			}

			i{
				font-size: 32px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				min-width: 100px;
				max-width: 100px;
				text-align: center;
				transform: scale(1);
				transition: 0.1s;
			}
			.text{
				display: flex;
				flex-direction: column;
				justify-content: center;
				font-size: 14px;

				small{
					display: block;
					font-size: 12px;
					font-weight: 500;
					padding-top: 4px;
				}
			}

			&:hover{
				text-decoration: none;

				.text b{
					text-decoration: underline;
				}

				i{
					color: var(--primary500);
					transform: scale(1.3);
				}
			}
		}
	}

</style>